import * as React from 'react'

import { getConfigBySite } from '../../../../config/sites'
import createAutoSuggestDataContainer from '../../../shared/components/autosuggest/autoSuggestDataContainer'
import createAutoSuggestLogicContainer from '../../../shared/components/autosuggest/autoSuggestLogicContainer'
import SeoHeadings from '../../../shared/components/seoHeadings/seoHeadings'
import AutoSuggest from '../../../v0/components/autosuggest/autosuggest'
import SearchHeader from '../../../v0/components/searchHeader'
import CommunitySection from './communitySection'
import FeaturedAuthorSection from './featuredAuthorSection'
import FeaturedItemsSection from './featuredItemsSection'
import FreeItemSection from './freeItemSection'
import MarketingSection from './marketingSection'
import NewestItemSection from './newestItemSection'

import PageSection from './pageSection'
import TutorialsSection from './tutorialsSection'

import * as seoHeadingsStyles from '../../../shared/components/seoHeadings/themes/homepage.module.css'
import * as autoSuggestStyles from '../../../v0/components/autosuggest/themes/homepage.module.css'
import * as searchHeaderStyles from '../../../v0/components/searchHeader/themes/homepage.module.css'
import * as styles from './homePage.module.css'

import { Props } from '../../../shared/containers/homePageContainer'

const AutoSuggestContainer = createAutoSuggestDataContainer(
  createAutoSuggestLogicContainer(AutoSuggest)
)

const HomePage = ({
  location,
  currentSite,
  isSignedIn,
  metadata,
  newestItemsData,
  featuredItems,
  freeItems,
  featuredAuthor,
  fetchNewestItemsByCategory,
  preferences,
  muteVideo,
  reportItemClick,
  makeSearchLink
}: Props) => {
  return (
    <div>
      <div className={styles.searchHeaderSection}>
        <SearchHeader currentSite={currentSite} styles={searchHeaderStyles}>
          {metadata && (
            <SeoHeadings
              TagName="h1"
              heading={metadata.search_area.heading}
              subHeading={metadata.search_area.sub_heading}
              styles={seoHeadingsStyles}
            />
          )}
          <AutoSuggestContainer
            inputName="term"
            value=""
            placeholder={getConfigBySite(
              currentSite,
              'home_search_placeholder'
            )}
            currentSite={currentSite}
            locationParams={{}}
            makeSearchLink={makeSearchLink}
            styles={autoSuggestStyles}
            showCategories={true}
          />
        </SearchHeader>
      </div>

      {metadata && (
        <FeaturedItemsSection
          name="Homepage: Featured items"
          items={featuredItems.slice(0, 10)}
          metadata={metadata.featured_items}
          muteVideo={muteVideo}
          videoMuted={preferences.searchVideoMuted}
          reportItemClick={reportItemClick}
          currentSite={currentSite}
        />
      )}

      {newestItemsData.items &&
        metadata && (
          <PageSection>
            <NewestItemSection
              name="Homepage: New items"
              currentSite={currentSite}
              fetchNewestItemsByCategory={fetchNewestItemsByCategory}
              metadata={metadata.newest_items}
              newestItemsData={newestItemsData}
              muteVideo={muteVideo}
              videoMuted={preferences.searchVideoMuted}
              reportItemClick={reportItemClick}
              nonSquare={
                !getConfigBySite(currentSite, 'homepage.newest_items_square')
              }
            />
          </PageSection>
        )}

      {metadata && (
        <PageSection borderTop>
          <FreeItemSection
            currentSite={currentSite}
            name="Homepage: Free files of the month"
            isSignedIn={isSignedIn}
            items={freeItems}
            metadata={metadata.free_items}
            muteVideo={muteVideo}
            videoMuted={preferences.searchVideoMuted}
            reportItemClick={reportItemClick}
          />
        </PageSection>
      )}

      {metadata && <MarketingSection blocks={metadata.marketing_blocks} />}

      {metadata && (
        <PageSection borderTop>
          <FeaturedAuthorSection
            currentSite={currentSite}
            name="Homepage: Featured authors"
            items={featuredAuthor.matches}
            author={featuredAuthor.author}
            metadata={metadata.featured_author}
            muteVideo={muteVideo}
            videoMuted={preferences.searchVideoMuted}
            reportItemClick={reportItemClick}
          />
        </PageSection>
      )}

      {metadata && <CommunitySection metadata={metadata.community} />}

      {metadata && (
        <PageSection>
          <TutorialsSection metadata={metadata.tutorials} />
        </PageSection>
      )}
    </div>
  )
}

export default HomePage
